'use client';

import { useGlobalLabels } from '@/context/GlobalLabelContext';
import { relatedTopicsVariants } from './RelatedTopics.styles';

export const RelatedTopicsLabel = () => {
  const {
    globalLabels: { related_topics_label },
  } = useGlobalLabels();

  const { headerText } = relatedTopicsVariants();

  return <p className={headerText()}>{related_topics_label || 'Related Topics'}</p>;
};
